export default class UnitPriceCalculationError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, UnitPriceCalculationError.prototype);
    }
}
